// A password box with an eye to show what you typed. Copy and paste work like
// any other field — nothing here blocks them on purpose.
import React, { forwardRef, useState } from 'react';
import './PasswordField.css';

const PasswordField = forwardRef(({ className = '', ...props }, ref) => {
  const [shown, setShown] = useState(false);
  return (
    <div className="pw-field">
      <input ref={ref} {...props} type={shown ? 'text' : 'password'} className={`${className} pw-input`}
        autoCapitalize="none" autoCorrect="off" spellCheck={false} />
      <button type="button" className="pw-eye" onClick={() => setShown((s) => !s)}
        aria-label={shown ? 'Hide password' : 'Show password'} aria-pressed={shown} tabIndex={-1}>
        {shown ? (
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M3 3l18 18M10.6 5.1A9.8 9.8 0 0 1 12 5c5 0 9 4.5 10 7-.4 1-1.3 2.4-2.6 3.7M6.3 6.3C4.3 7.6 2.8 9.6 2 12c1 2.5 5 7 10 7 1.7 0 3.3-.5 4.7-1.3M9.9 9.9a3 3 0 0 0 4.2 4.2"/></svg>
        ) : (
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="none" stroke="currentColor" strokeWidth="2" d="M2 12c1-2.5 5-7 10-7s9 4.5 10 7c-1 2.5-5 7-10 7S3 14.5 2 12z"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/></svg>
        )}
      </button>
    </div>
  );
});

export default PasswordField;
